import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { PlatformMax, PlatformTelegram } from '@smmof/entity';

export type MyPlatform = PlatformTelegram | PlatformMax;

export const MyPlatformsActions = createActionGroup({
  source: '[My Platforms] API',
  events: {
    'Load My Platforms': emptyProps(),
    'Load My Platforms Success': props<{ platforms: MyPlatform[] }>(),
    'Load My Platforms Failure': props<{ error: any }>(),
  },
});
